import axios from 'axios';

const API_KEY = '340677b6';
const BASE_URL = 'https://www.omdbapi.com/';

// Search for movies by title with optional type filter
export const searchMovies = async (title, page = 1, type = '') => {
  try {
    let url = `${BASE_URL}?s=${encodeURIComponent(title)}&page=${page}&apikey=${API_KEY}`;
    if (type) {
      url += `&type=${type}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error searching movies:', error);
    throw error;
  }
};

// Get detailed information about a specific movie by IMDb ID
export const getMovieDetails = async (imdbID) => {
  try {
    const response = await axios.get(`${BASE_URL}?i=${imdbID}&apikey=${API_KEY}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching movie details:', error);
    throw error;
  }
};
